// extracted by mini-css-extract-plugin
export default {"tasks":"ZL-z","task":"_L-z","svg":"aM-z","text":"bM-z"};